module.exports = __webpack_public_path__ + "media/images/wendys-artwork-b93934d9ea7cc569ee8ba7de052ea080.png";